;(function () {
  'use strict'

  angular.module('contrast.highcharts').factory(
    'highchartsColorService',
    // eslint-disable-next-line angular/di-unused
    function highchartsColorServiceFactory(
      Highcharts,
      HIGHCHARTS_COLORS,
      HIGHCHARTS_CHART_TYPES
    ) {
      'ngInject'

      return {
        getGradientColor: getGradientColor,
        setDefaultSeriesColor: setDefaultSeriesColor,
        setHoverSeriesColor: setHoverSeriesColor,
        setDisabledSeriesColor: setDisabledSeriesColor
      }

      /**
       * @description Builds a Highcharts Gradient Color Configuration object
       * @param stops - Array of n objects where each object has to include the position[where 0 is the start of the gradient and 1 is the end of the gradient],
       * the opacity level and the color. Each object is gonna represent a color in the given position.
       * @returns {Highcharts Gradient Color Object}
       */
      function getGradientColor(stops) {
        return {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          },
          stops: stops.map(function (s) {
            return [
              s.position,
              Highcharts.Color(s.color).setOpacity(s.opacity).get('rgba')
            ]
          })
        }
      }

      function _updateSeriesColor(
        seriesElement,
        color,
        initialOpacity,
        finalOpacity
      ) {
        switch (seriesElement.type) {
          case HIGHCHARTS_CHART_TYPES.AREA:
            seriesElement.update(
              {
                color: color,
                fillColor: getGradientColor([
                  {
                    position: 0,
                    color: color,
                    opacity: initialOpacity ? initialOpacity : 0.15
                  },
                  {
                    position: 1,
                    color: color,
                    opacity: finalOpacity ? finalOpacity : 0
                  }
                ])
              },
              false
            )
            break

          case HIGHCHARTS_CHART_TYPES.COLUMN:
            seriesElement.update(
              {
                color: color
              },
              false
            )
            break

          default:
            seriesElement.update(
              {
                color: color
              },
              false
            )
        }
      }

      function _updateSeriesColorByPoint(seriesElement, colors) {
        seriesElement.update(
          {
            colors: colors
          },
          false
        )
      }

      function setDefaultSeriesColor(series) {
        angular.forEach(series, function (seriesElement) {
          if (seriesElement.options.colorByPoint) {
            _updateSeriesColorByPoint(
              seriesElement,
              seriesElement.options.colorsDefault
            )
          } else {
            _updateSeriesColor(
              seriesElement,
              seriesElement.options.colorDefault
            )
          }
        })
      }

      function setHoverSeriesColor(series) {
        angular.forEach(series, function (seriesElement) {
          if (seriesElement.options.colorByPoint) {
            _updateSeriesColorByPoint(
              seriesElement,
              seriesElement.options.colorsHover
                ? seriesElement.options.colorsHover
                : seriesElement.options.colorsDefault
            )
          } else {
            _updateSeriesColor(
              seriesElement,
              seriesElement.options.colorHover
                ? seriesElement.options.colorHover
                : seriesElement.options.colorDefault
            )
          }
        })
      }

      function setDisabledSeriesColor(series) {
        angular.forEach(series, function (seriesElement) {
          if (seriesElement.options.colorByPoint) {
            _updateSeriesColorByPoint(
              seriesElement,
              seriesElement.options.colorsDisabled
            )
          } else {
            _updateSeriesColor(
              seriesElement,
              seriesElement.options.colorDisabled
            )
          }
        })
      }
    }
  )
})()
